
import { Component, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../framework/state';
import { ValidationObserver } from 'vee-validate';
import EmailField from '../../../framework/fields/EmailField.vue';
import PasswordField from '../../../framework/fields/PasswordField.vue';
import { FrameworkFeature } from '../../../../common/framework/enumeration/FrameworkFeature';
import { passwordLogin } from '../../../framework/service/authentication_service';
import { isToyotaFleetPortal } from '../../service/toyota_finance_finland.service';

@Component({
    components: { EmailField, PasswordField, ValidationObserver },
})
export default class SmartFleetLoginView extends Vue {
    shared = sharedState;
    local = {
        email: '',
        password: '',
        isToyotaFleetPortal: isToyotaFleetPortal(),
    };

    mounted() {
        if (
            !sharedState.enabled(FrameworkFeature.PASSWORD_AUTHENTICATION) &&
            sharedState.enabled(FrameworkFeature.SAML_AUTHENTICATION)
        ) {
            window.location.href = '/saml/login';
        }
        if (this.shared.email) {
            this.local.email = this.shared.email;
        }
    }

    async login() {
        const email = this.local.email!!;
        const password = this.local.password!!;
        if (await passwordLogin(email, password)) {
            this.local.email = '';
            this.local.password = '';
            sharedState.email = '';
            if (sharedState.routeAfterLogin) {
                this.$router.replace(sharedState.routeAfterLogin);
                sharedState.routeAfterLogin = '';
            } else {
                this.$router.replace('/');
            }
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.loginFailed').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }

    forgotPassword() {
        this.$router.push('/login/request-password-change');
    }

    get showLogin(): boolean {
        return !this.shared.authenticated && this.shared.enabled(FrameworkFeature.PASSWORD_AUTHENTICATION);
    }
}
